module.exports = __webpack_public_path__ + "e58a25bcbc85d738302cf9eb06855191.png";